import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    quiz: {},
    openModal: false
};

const quizzesSlice = createSlice({
    name: "quizzes",
    initialState,
    reducers: {
        editQuiz: (state, action) => {
            state.quiz = action.payload;
        },
        toggleModal: (state, action) => {
            state.openModal = action.payload
        }
    },
});

export const { editQuiz, toggleModal } = quizzesSlice.actions;
export default quizzesSlice.reducer;
